<template>
  <v-dialog v-model="dialog" width="500" @click:outside="$emit('close-new-character-dialog', false)">
    <v-card>
      <v-card-title v-if="character.id != null">
        キャラクター編集
      </v-card-title>
      <v-card-title v-else>キャラクター作成</v-card-title>
      <v-card-text>
        <v-form ref="characterForm" v-model="valid">
          <v-text-field
            v-model="character.name"
            style="width: 300px"
            label="キャラクター名"
          >
            <template v-slot:label>
              <InputLabel label-name="キャラクター名" :required="false" />
            </template>
          </v-text-field>
          <ImageFormAndThumbnail
            ref="imageFormAndThumbnail"
            label-name='キャラクター画像'
            :requiredImageFile="character.avatar ? false : true"
            :propsImagePreviewURL="character.avatar ? character.avatar.url : ''"
            @change-image-file="(value) => character.avatar = value"
          ></ImageFormAndThumbnail>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="character.id != null"
          color="green darken-1"
          text
          @click="updateCharacter"
        >
          更新する
        </v-btn>
        <v-btn v-else color="green darken-1" text @click="createCharacter">
          作成する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import ImageFormAndThumbnail from '@/components/commons/ImageFormAndThumbnail'

export default {
  components: {
    InputLabel,
    ImageFormAndThumbnail
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    character: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      valid: true
    }
  },
  watch: {
    dialog (value) {
      if (value == false) {
        this.$refs.imageFormAndThumbnail.imageFile = null
        this.$refs.imageFormAndThumbnail.imagePreviewURL = null
      }
    }
  },
  methods: {
    validateForm () {
      this.valid = this.$refs.characterForm.validate()
    },
    updateCharacter () {
      this.validateForm()
      if (!this.valid) {
        return false
      }

      this.$emit('update-character', this.character)
      this.valid = true
    },
    createCharacter () {
      this.validateForm()
      if (!this.valid) {
        return false
      }

      this.$emit('create-character', this.order)
      this.valid = true
    }
  }
}
</script>
